import { render } from "./UploadFileImage.vue?vue&type=template&id=10b6eab8&scoped=true&ts=true"
import script from "./UploadFileImage.vue?vue&type=script&lang=ts"
export * from "./UploadFileImage.vue?vue&type=script&lang=ts"

import "./UploadFileImage.vue?vue&type=style&index=0&id=10b6eab8&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b6eab8"]])

export default __exports__